import { useState, useEffect } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import CartItem from "../components/cards/CartItem.jsx";
import { HiViewList } from "react-icons/hi";
import { RiFileListFill, RiFlag2Line } from "react-icons/ri";
import { test_ip } from "../services/constants.js";
import {
  MdShoppingBasket,
  MdStarOutline,
  MdAccessTime,
  MdDeliveryDining,
  MdCreditCard,
  MdSmartphone,
} from "react-icons/md";
import { BsCash } from "react-icons/bs";

import { setError } from "../services/actions";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

const OrderHistoryDetail = () => {
  const [orderHistory, setOrderHistory] = useState();
  const [currentPage, setCurrentPage] = useState("details");
  const loc = useLocation();
  const nav = useNavigate();
  const diapach = useDispatch();

  useEffect(() => {
    // Order_history_detail(  { user_id: '607425ec2015810d56e0c4f6',
    //                             server_token: 'g4rkAI9ZLL5Cl2peHrp8uRvSEB2tTHkn',
    //                             order_id: '621cc2a7ea61451e4c5cc26b' }) //you would get order_id from order_history list as _id
    var user = JSON.parse(localStorage.getItem("user"));
    var data = {
      user_id: user.user_id,
      server_token: user.server_token,
      order_id: loc.state.item.value._id,
    };
    console.log(loc.state.item);
    Order_history_detail(data);
  }, []);

  const Order_history_detail = function (data) {
    // Order history details
    var body = data;
    body = JSON.stringify(body);
    axios
      .post(`${test_ip}api/user/order_history_detail`, body, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          console.log(res.data);
          if (res.data.success == true) {
            setOrderHistory(res.data);
          } else {
            console.log(res.data.error_code);
            if (res.data.error_code == 999) {
              console.log(true);
              toast.error("Please Login !", {
                position: toast.POSITION.TOP_RIGHT,
              });
              localStorage.clear();
              window.location.reload();
              console.log("sdfgh");
            } else {
              diapach(
                setError({
                  error: true,
                  message: `failed, please check again(${res.data.error_code})`,
                })
              );
            }
          }
        } else {
          // do something
          // console.log("erororor", res.data.error_code);
          if (res.data.error_code == 999) {
            // console.log(true);
            toast.error("Please Login !", {
              position: toast.POSITION.TOP_RIGHT,
            });
            localStorage.clear();
            window.location.reload();
            // console.log("sdfgh");
          } else {
            diapach(
              setError({
                error: true,
                message: `failed, please check again(${res.data.error_code})`,
              })
            );
          }
        }
      })
      .catch((err) => {
        // do something
        diapach(setError({ error: true, message: "failed,please reload" }));
        // console.log(err);
      });
  };

  const handlePage = (page) => {
    setCurrentPage(page);
  };

  const handleStoreRating = () => {
    nav("/store-rating", {
      state: {
        item: orderHistory,
      },
    });
  };

  const handleProviderRating = () => {
    nav("/provider-rating", {
      state: {
        item: orderHistory,
      },
    });
  };

  return (
    <div className="a-order-history-detail-page">
      <div className="a-order-history-info">
        <div className="a-buttons">
          <button
            className={currentPage === "details" ? "btn-active" : ""}
            onClick={() => {
              handlePage("details");
            }}
          >
            <HiViewList size={25} color="var(--primary-color)" />
            <br />
            Details
          </button>
          <button
            className={currentPage === "invoice" ? "btn-active" : ""}
            onClick={() => {
              handlePage("invoice");
            }}
          >
            <RiFileListFill size={25} color="var(--primary-color)" />
            <br />
            Invoice
          </button>
          <button
            className={currentPage === "cart" ? "btn-active" : ""}
            onClick={() => {
              handlePage("cart");
            }}
          >
            <MdShoppingBasket size={25} color="var(--primary-color)" />
            <br />
            Cart
          </button>
        </div>
      </div>
      <div className={currentPage === "details" ? "page page-active" : "page"}>
        <div className="a-product-name">
          <h3>Order Details</h3>
        </div>
        <div className="a-rate-name-container">
          <div className="a-name-img">
            <div className="a-img-container">
              <img
                style={{
                  width: "100%",
                  borderRadius: "50%",
                }}
                src="zmall-logo.png"
                alt="logo"
              />
            </div>
            <div className="a-name-description">
              <p>{orderHistory && orderHistory.store_detail.name}</p>
              <p>Order received by</p>
              <p>
                {orderHistory &&
                  orderHistory.order_list.cart_detail.destination_addresses[0]
                    .user_details.name}
              </p>
            </div>
          </div>
          <div
            className={
              orderHistory &&
              (orderHistory.order_list.delivery_type == 1
                ? "page page-active"
                : "page")
            }
            style={{
              display:
                orderHistory &&
                orderHistory.order_list.order_status == 101 &&
                "none",
            }}
          >
            <div className="a-rate">
              <MdStarOutline
                fill={
                  orderHistory &&
                  orderHistory.order_list.is_user_rated_to_store &&
                  "var(--primary-color)"
                }
                size={25}
              />
              <button
                onClick={
                  orderHistory &&
                  (orderHistory.order_list.is_user_rated_to_store
                    ? ""
                    : handleStoreRating)
                }
              >
                Give Rate
              </button>
            </div>
          </div>
        </div>
        <div className="a-product-name">
          <h3>Delivery Details</h3>
        </div>
        <div
          className="a-user-cancel"
          style={{
            display:
              orderHistory &&
              (orderHistory.order_list.order_status == 101 ? "block" : "none"),
          }}
        >
          Cancelled by user
        </div>
        <div
          className="a-rate-name-container"
          style={{
            display:
              orderHistory &&
              orderHistory.order_list.order_status == 101 &&
              "none",
          }}
        >
          <div className="a-name-img">
            <div className="a-img-container">
              <img
                style={{
                  width: "100%",
                  borderRadius: "50%",
                }}
                src="zmall-logo.png"
                alt="logo"
              />
            </div>
            <div className="a-name-description">
              <p>{orderHistory && orderHistory.provider_detail.first_name}</p>
            </div>
          </div>
          <div>
            <div className="a-rate">
              <MdStarOutline
                fill={
                  orderHistory &&
                  orderHistory.order_list.is_user_rated_to_provider &&
                  "var(--primary-color)"
                }
                size={25}
              />
              <button
                onClick={
                  orderHistory &&
                  (orderHistory.order_list.is_user_rated_to_provider
                    ? ""
                    : handleProviderRating)
                }
              >
                Give Rate
              </button>
            </div>
          </div>
        </div>
        <div className="a-detail-description">
          <p>
            <RiFlag2Line fill="var(--primary-color)" size={20} />
            &nbsp;&nbsp;&nbsp;
            {orderHistory &&
              orderHistory.order_list.cart_detail.pickup_addresses[0].address}
          </p>
          <p>
            <RiFlag2Line size={20} />
            &nbsp;&nbsp;&nbsp;
            {orderHistory &&
              orderHistory.order_list.cart_detail.destination_addresses[0]
                .address}
          </p>
          <p>
            <MdAccessTime fill="var(--primary-color)" size={20} />
            &nbsp;&nbsp;&nbsp;
            {orderHistory &&
              orderHistory.order_list.order_payment_detail.total_time}{" "}
            mins
          </p>
          <p>
            <MdDeliveryDining size={20} />
            &nbsp;&nbsp;&nbsp;
            {orderHistory &&
              orderHistory.order_list.order_payment_detail.total_distance}{" "}
            KM
          </p>
        </div>
      </div>
      <div className={currentPage === "invoice" ? "page page-active" : "page"}>
        <div className="a-header-info">
          <p>
            <MdAccessTime style={{ float: "left" }} size={20} />
            &nbsp;
            {orderHistory &&
              orderHistory.order_list.order_payment_detail.total_time}{" "}
            mins
          </p>
          <p>
            <MdDeliveryDining style={{ float: "left" }} size={20} />
            &nbsp;
            {orderHistory &&
              orderHistory.order_list.order_payment_detail.total_distance}{" "}
            KM
          </p>
          <p>
            <MdCreditCard style={{ float: "left" }} size={20} />
            &nbsp;
            {orderHistory && orderHistory.payment_gateway_name}
          </p>
        </div>
        <div className="a-payment-info">
          <p>
            <p>Service Price </p>
            <p>
              {orderHistory && orderHistory.currency}{" "}
              {orderHistory &&
                orderHistory.order_list.order_payment_detail
                  .total_delivery_price}
            </p>
          </p>
          <p style={{ color: "var(--primary-color)" }}>
            <p>Total Service Price </p>
            <p>
              {orderHistory && orderHistory.currency}{" "}
              {orderHistory &&
                orderHistory.order_list.order_payment_detail
                  .total_delivery_price}
            </p>
          </p>
          <p>
            <p>cart Price </p>
            <p>
              {orderHistory && orderHistory.currency}{" "}
              {orderHistory &&
                orderHistory.order_list.order_payment_detail.total_cart_price}
            </p>
          </p>
          <p style={{ color: "var(--primary-color)" }}>
            <p>Total cart Price </p>
            <p>
              {orderHistory && orderHistory.currency}{" "}
              {orderHistory &&
                orderHistory.order_list.order_payment_detail.total_cart_price}
            </p>
          </p>
        </div>
        <div className="a-total-price-bottom">
          <div className="a-total-price-top">
            <div>
              <MdSmartphone size={20} />
              &nbsp;&nbsp;
              <p style={{ display: "inline-block" }}>
                Online <br />
                {orderHistory && orderHistory.currency}&nbsp;
                {orderHistory &&
                  orderHistory.order_list.order_payment_detail.wallet_payment}
              </p>
            </div>
            <div>
              <BsCash size={20} />
              &nbsp;&nbsp;&nbsp;
              <p style={{ display: "inline-block" }}>
                Cash <br />
                {orderHistory && orderHistory.currency}{" "}
                {orderHistory &&
                  orderHistory.order_list.order_payment_detail.cash_payment}
              </p>
            </div>
          </div>
          <p style={{ fontSize: "0.8rem" }}>Total</p>
          <p
            style={{
              fontWeight: "bold",
              fontSize: "1.2rem",
            }}
          >
            {orderHistory && orderHistory.currency}{" "}
            {orderHistory && orderHistory.order_list.order_payment_detail.total}
          </p>
          <p style={{ fontSize: "0.8rem" }}>
            {" "}
            {orderHistory && orderHistory.payment_gateway_name}
          </p>
        </div>
      </div>
      <div className={currentPage === "cart" ? "page page-active" : "page"}>
        {orderHistory &&
          orderHistory.order_list.cart_detail.order_details.map((od) => {
            return <CartItem item={od} />;
          })}
      </div>
    </div>
  );
};

export default OrderHistoryDetail;
